import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from '@mui/material';

import { sxStyled } from './styles';

const TimedModal = ({ onReloadSearch, searchResults }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  useEffect(() => {
    if (searchResults?.clusters?.length > 0) {
      const timer = setTimeout(() => {
        setOpen(true);
        //  }, 7 * 60 * 1000); // 7 minutos
      }, 7 * 60 * 1000); // 7 minutos

      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchResults?.clusters?.length]);

  const handleUpdate = () => {
    setOpen(false);
    onReloadSearch();
  };

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: sxStyle.paper,
      }}
      disableEnforceFocus
    >
      <DialogTitle sx={{ padding: '24px' }}>
        <Typography variant="h4" component="div" sx={sxStyle.title}>
          Ha pasado mucho tiempo.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="subtitle1" sx={sxStyle.subtitle}>
          Es posible que las tarifas hayan cambiado.
        </Typography>
      </DialogContent>

      <DialogActions sx={sxStyle.actions}>
        <Button
          onClick={handleUpdate}
          color="primary"
          variant="contained"
          sx={{
            ...sxStyle.button,
            bgcolor: theme.primary,
            color: theme.text1,
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimedModal;
